package chand.wordvoyage.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

// OpenAI API Models

@Serializable
data class OpenAIChatRequest(
    val model: String,
    val messages: List<ChatMessage>,
    val temperature: Double? = null,
    @SerialName("max_completion_tokens")
    val maxCompletionTokens: Int? = null
)

@Serializable
data class ChatMessage(
    val role: String,  // "user", "assistant", "system"
    val content: String
)

@Serializable
data class OpenAIChatResponse(
    val id: String? = null,
    @SerialName("object")
    val objectType: String? = null,
    val created: Long? = null,
    val model: String? = null,
    val choices: List<Choice>? = null,
    val usage: UsageInfo? = null,
    val error: OpenAIErrorDetail? = null
)

@Serializable
data class Choice(
    val index: Int? = null,
    val message: ChatMessage? = null,
    @SerialName("finish_reason")
    val finishReason: String? = null
)

@Serializable
data class UsageInfo(
    @SerialName("prompt_tokens")
    val promptTokens: Int? = null,
    @SerialName("completion_tokens")
    val completionTokens: Int? = null,
    @SerialName("total_tokens")
    val totalTokens: Int? = null
)

@Serializable
data class OpenAIErrorDetail(
    val message: String? = null,
    val type: String? = null,
    val param: String? = null,
    val code: String? = null
)


